import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const InsightDisplay = ({ userQuery, insight }) => {

  const parseInsights = (insightText) => {
    if (!insightText) return null;

    let cleaned = insightText.trim();
    // Remove markdown code blocks if present
    if (cleaned.startsWith('```')) {
      cleaned = cleaned.replace(/^```[a-zA-Z]*\n?/, '').replace(/```$/, '');
    }

    try {
      const parsed = JSON.parse(cleaned);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      // If not JSON, return as plain text
      return [{ 'Insight': cleaned }];
    }
  };

  const insightList = parseInsights(insight);

  const titleMap = {
    'Key metrics and their significance': '📌 Key Metrics',
    'Notable patterns or trends': '📈 Trends & Patterns',
    'Business implications': '💡 Business Implications',
    'Potential action items': '✅ Action Items',
  };

  return (
    <Box sx={{ mt: 2 }}>
      {/* User Query */}
      {userQuery && (
        <Paper sx={{ p: 2, mb: 2, bgcolor: '#e3f2fd', border: '1px solid #2196f3' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: 'var(--text-link)' }}>
            🛠️ Your Question
          </Typography>
          <Typography variant="body1" sx={{ color: '#424242' }}>{userQuery}</Typography>
        </Paper>
      )}

      {/* Insights */}
      {insightList && (
        <Paper sx={{ p: 2, mb: 2, bgcolor: '#f1f8e9', border: '1px solid #8bc34a' }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#558b2f' }}>
            📊 Insights
          </Typography>
          {insightList.map((item, index) => {
            const key = Object.keys(item)[0];
            const value = item[key];
            const title = titleMap[key] || `📍 ${key}`;

            return (
              <Accordion key={index} sx={{ mb: 1, bgcolor: 'white' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#424242' }}>
                    {title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {key.toLowerCase().includes('action item') ? (
                    <Box component="ul" sx={{ pl: 3 }}>
                      {value
                        .split(/\d+\.\s+/)
                        .filter(Boolean)
                        .map((point, i) => (
                          <Typography component="li" key={i} sx={{ mb: 1, color: '#424242' }}>
                            {point.trim()}
                          </Typography>
                        ))}
                    </Box>
                  ) : (
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-line', color: '#424242' }}>
                      {value}
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Paper>
      )}
    </Box>
  );
};

export default InsightDisplay;

